<div class="text-grey">
  <div class="text-grey">
    <div class="modal-header">
      <h4 class="modal-title synchpc-primary" id="modal-title">
        Request Visual Studio Code Server
      </h4>
      <i
        style="z-index: 1"
        class="bi bi-x-lg text-danger"
        color="warn"
        (click)="onClose()"
        title="Close"
      ></i>
    </div>
  </div>

  <div class="modal-body" style="max-height: 75vh; overflow: auto">
    <form [formGroup]="codeServerForm">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Code Server Password</mat-label>
        <input
          matInput
          formControlName="password"
          placeholder="auto-generated if empty"
        />
        <mat-error *ngIf="codeServerForm.get('password')?.hasError('required')">
          Password is required
        </mat-error>
      </mat-form-field>

       <mat-form-field appearance="fill" class="full-width">
          <mat-label>GPU Request/Limit</mat-label>
          <input
            type="text"
            matInput
            formControlName="gpu"
            [matAutocomplete]="autoGpu"
            placeholder="e.g., 1/1"
          />
          <mat-autocomplete #autoGpu="matAutocomplete">
            <mat-option *ngFor="let opt of gpuOptions" [value]="opt.value">
              {{ opt.label }}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="codeServerForm.get('gpu')?.hasError('invalidGpu')">
            GPU format must be like `1/1`, and left value must be less than
            right.
          </mat-error>
        </mat-form-field>
      <div class="form-row">

        <mat-form-field appearance="fill" class="half-width">
          <mat-label>CPU Request/Limit</mat-label>
          <input
            type="text"
            matInput
            formControlName="cpu"
            [matAutocomplete]="autoCpu"
            placeholder="e.g., 500m/1000m"
          />
          <mat-autocomplete #autoCpu="matAutocomplete">
            <mat-option *ngFor="let opt of cpuOptions" [value]="opt.value">
              {{ opt.label }}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="codeServerForm.get('cpu')?.hasError('invalidCpu')">
            CPU format must be like `500m/1000m`, and left value must be less
            than right.
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="half-width">
          <mat-label>Memory Request/Limit</mat-label>
          <input
            type="text"
            matInput
            formControlName="memory"
            [matAutocomplete]="autoMem"
            placeholder="e.g., 512Mi/1Gi"
          />
          <mat-autocomplete #autoMem="matAutocomplete">
            <mat-option *ngFor="let opt of memoryOptions" [value]="opt.value">
              {{ opt.label }}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="codeServerForm.get('memory')?.hasError('invalidMemory')">
            Memory format must be like `512Mi/1Gi`, and left value must be less
            than right.
          </mat-error>
        </mat-form-field>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onClose()">
      Close
    </button>
    <button type="button" class="btn btn-primary" (click)="onSubmit()">
      Submit
    </button>
  </div>
</div>
